import Category from "./Category"

function Catalog() {
  return (
    <Category />
  )
}

export { Catalog }